define('views/InvestorsView',[
    'backbone',
    'lodash',
    'app',
    'lib/MouseAnim',
    'lib/easing',
    'views/LoginFormView',
    'text!templates/investors-login.html',
    'text!templates/investors-pdf.html'
], function (Backbone, _, App, MouseAnim, easing, LoginFormView, loginTmpl, pdfTmpl) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        loginTemplate: _.template(loginTmpl),

        events: {
            'click .execution-copies': 'showPdfModal',
            'click .close': 'hidePdfModal'
        },

        render: function () {
            if (App.auth) {
                // render content
                $.when(this.getContentTmpl()).done(_.bind(function (template) {
                    // clear login form
                    if (this.loginForm) {
                        this.loginForm.remove();
                    }

                    this.renderContent(template);
                }, this));
            } else {
                this.$el.html(this.loginTemplate(App));
                this.loginForm = new LoginFormView({
                    success: _.bind(this.onLogin, this)
                });
                this.$el.find('.login').html(this.loginForm.el);
            }
        },

        preload: function () {
            if (App.auth) {
                $.when(this.getContentTmpl()).done(function (template) {
                    template.call(this, App);
                }, this);
            }
        },

        onLogin: function () {
            if (!App.auth) { // in case when users submit login form muliple times 
                App.auth = true;
                this.render();
            }
        },

        getContentTmpl: function () {
            // find cache first
            if (this.constructor.template) {
                return this.constructor.template;
            }
            // fetch template
            else {
                return $.get(App.route('templates/investors.html')).then(_.bind(function (tmplStr) {
                    var template = _.template(tmplStr);
                    this.constructor.template = template;
                    return template;
                }, this));
            }
        },

        /**
         * Render the password protected content
         */
        renderContent: function (template) {
            this.$el.html(template.call(this, App));
            this.mouseAnim = new MouseAnim();

            this.$el.find('.parallels-grid').each(_.bind(function (i, e) {
                this.initParallelsGrid(e);
            }, this));
        },

        initParallelsGrid: function (grid) {
            var $grid = $(grid),
                parallels = $grid.find('.parallels');
                // classNameK = 0;

            this.mouseAnim.add(function (pos) {
                var offset = $grid.offset(),
                    center = {
                        x: offset.left + $grid[0].offsetWidth,
                        y: offset.top
                    },
                    moved = (pos.mousePos.x - center.x) + (pos.mousePos.y - center.y),
                    max = $grid[0].offsetWidth * 2,
                    range = [-max, max],
                    translate = (easing.range(moved, range, 'easeInOutCubic') - 0.3) * 40;

                // round translate to 2 decimal pts for performance
                translate = Math.round(translate * 10) / 10;

                // translate y
                $(parallels[0]).css('transform', 'translateY(' + translate + '%)');
                $(parallels[1]).css('transform', 'translateY(' + -translate + '%)');
                $(parallels[2]).css('transform', 'translateY(' + translate + '%)');

                // classNames
                /*
                var k = Math.floor( (pos.mousePos.x - offset.left) / ($grid[0].offsetWidth / 3) );
                if (k !== classNameK) {
                    parallels.each(function (i) {
                        var col = k + i;
                        col = col > 2 ? col - 3 : (col < 0 ? col + 3 : col);
                        this.className = this.className.replace(/col-[0-9]/, ' col-' + col + '');
                    });
                    classNameK = k;
                }
                */
            });
        },

        showPdfModal: function (event) {
            this.pdf = event.currentTarget.getAttribute('data-pdf');

            if (!this.$modal) {
                this.$modal = $(_.template(pdfTmpl).apply(this, [App]));
                this.$el.append(this.$modal);
            }
        },

        hidePdfModal: function () {
            if (this.$modal) {
                this.$modal.remove();
                this.$modal = null;
            }
        },

        remove: function () {
            if (this.mouseAnim) {
                this.mouseAnim.destroy();
            }
            if (this.loginForm) {
                this.loginForm.remove();
            }
            Backbone.View.prototype.remove.call(this);
        }

    });

});
